import EnrollmentTypeEnum from "../EnrollmentType/EnrollmentTypeEnum";
import InstitutionDetails from "../Institution/InstitutionDetails";
import InstitutionProgram from "../Institution/InstitutionProgram";
import ApplicantParent from "../Person/ApplicantParent";
import Child from "../Person/Child";
import OtherParent from "../Person/OtherParent";
import ParentNumberEnum from "../Person/ParentNumberEnum";
import InitialConversationQuestionGroup from "./InitialConversationQuestionGroup";
import RequestCriterionData, { requestCriterionDataInitial } from "./RequestCriterionData";
import RequestStatus from "./RequestStatus";
import RequestTypeEnum from "./RequestTypeEnum";

export default interface Request {
  uId: string;
  status: RequestStatus;
  parentNumberId: ParentNumberEnum;
  parentNumber: string;
  applicantParent: ApplicantParent;
  otherParent?: OtherParent;
  child: Child;
  createdByAdmin: boolean;
  createdByAppUserID?: number;
  requestTypeId: RequestTypeEnum;
  importantDateId?: number;
  enrollmentTypeId: number;
  monthId?: number;
  //TODO: Remove selectedPedagogicalYearInstitutionId, already in selectedInstitution
  selectedPedagogicalYearInstitutionId?: number;
  selectedInstitution: InstitutionDetails;
  institutionPrograms: InstitutionProgram[];
  criterionData: RequestCriterionData;
  initialConversationQuestionGroups: InitialConversationQuestionGroup[];
}

export const RequestInitial: Request = {
  uId: "",
  status: {} as RequestStatus,
  parentNumberId: {} as ParentNumberEnum,
  parentNumber: "",
  applicantParent: {} as ApplicantParent,
  otherParent: {} as OtherParent,
  child: {} as Child,
  selectedPedagogicalYearInstitutionId: undefined,
  selectedInstitution: {} as InstitutionDetails,
  institutionPrograms: [],
  criterionData: requestCriterionDataInitial,
  initialConversationQuestionGroups: [],
  createdByAdmin: false,
  createdByAppUserID: undefined,
  requestTypeId: RequestTypeEnum.Kindergarten,
  enrollmentTypeId: EnrollmentTypeEnum.RegularEnrollment,
};
